export enum CountdownTypes {
  DAYS = 'days',
  FULL = 'full',
  ROUND = 'round',
  FLAT = 'flat',
}
